import { Dialog } from '@headlessui/react';

export interface InviteOnlyModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function InviteOnlyModal(props: InviteOnlyModalProps) {
  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)} className="relative z-10">
      {/* DialogBackdrop */}
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <Dialog.Panel
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left
            shadow-xl sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
          >
            <div>
              <div className="mt-3 text-center sm:mt-5">
                <Dialog.Title as="h3" className="text-base font-semibold text-gray-900">
                  Invitation Only
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Signup not allowed, this app is invite-only for now. If you have an invite,
                    please use the link you received.
                  </p>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
